import ValidationService from './ValidationService';

class RegistrationFormService {
  static validateEmail(email) {
    if (!email) {
      return 'registration.error_email_invalid';
    }

    if (!ValidationService.isValidEmail(email, true)) {
      return 'registration.error_email_invalid';
    }

    return '';
  }

  static validatePassword(isPasswordStrongEnough) {
    if (!isPasswordStrongEnough) {
      return 'registration.error_password_not_strong';
    }
    return '';
  }

  static validateFirstName(name) {
    if (!ValidationService.isValidFirstName(name)) {
      return 'registration.error_first_name';
    }
    return '';
  }

  static validateLastName(name) {
    if (!name) {
      return '';
    }

    if (!ValidationService.validateLastName(name)) {
      return 'registration.error_last_name';
    }
    return '';
  }

  static validateProvinceTerritory(province) {
    if (!province) {
      return 'registration.error_province_required';
    }
    return '';
  }

  static validateSecurityQuestion(question) {
    if (!question) {
      return 'registration.error_security_question_required';
    }
    return '';
  }

  static validateSecurityQuestionAnswer(answer) {
    if (!answer) {
      return 'registration.error_security_question_answer_required';
    }
    return '';
    }

    static validateSecurityQuestionHint(answer, hint) {
        if (hint && hint === answer) {
            return 'registration.error_security_question_hint';
        }
        return '';
    }

  static validateNonRequiredEmail(email) {
    if (!ValidationService.isValidEmail(email, false)) {
      return 'registration.error_email_invalid';
    }
    return '';
  }

  static validatePhoneNumber(value) {
    if (!value) {
      return '';
    }
    if (!ValidationService.isValidPhoneNumber(value)) {
      return 'registration.error_phone_number';
    }
    return '';
  }
}

export default RegistrationFormService;